<template>
  <div>
    <base-loading title="Generando referencia" v-if="isLoading"></base-loading>
    <v-container
      class="fill-height"
      v-else
      transition="fade-transition"
      ref="downloadSection"
    >
      <v-row align="center" justify="center">
        <v-col xl="5" lg="6" md="7">
          <v-card shaped outlined class="py-5">
            <v-card-title class="justify-center font-weight-bold">
              Pago con OXXO
            </v-card-title>
            <v-card-text class="px-8">
              <div class="text-center mb-4">
                <div class="d-flex align-center justify-center mb-1 mt-4">
                  <span class="text-h4 mb-0 mr-2 black--text">$</span>
                  <span class="text-h2 mb-0 black--text font-weight-regular">{{
                    formatCurrency(amount)
                  }}</span>
                </div>
                <div class="total text-uppercase">Total a pagar</div>
                <barcode
                  class="mt-3"
                  :value="reference"
                  :options="barCodeOptions"
                >
                </barcode>
                <div v-if="!isBarcodeValid" class="my-14 red--text">
                  <div class="text-body-1 title font-weight-medium">
                    Ocurrió un error al generar el código de barras :(
                  </div>
                </div>
              </div>
              <v-alert outlined dense type="info" class="text-body-2">
                <span class="pl-1">
                  Tu pago se verá reflejado en aproximadamente 20 horas o
                  más</span
                >
              </v-alert>
              <div class="text-center">
                <div class="subtitle mt-7 font-weight-bold">Instrucciones</div>
              </div>
              <div class="text-body-1 mt-4">
                <ol>
                  <li>Acude a tu tienda OXXO más cercana.</li>
                  <li>
                    Indica en la caja que quieres hacer un pago de
                    <strong>OXXO Pay</strong>.
                  </li>
                  <li>
                    Dicta al cajero el número de referencia en esta ficha.
                  </li>
                  <li>
                    Realiza el pago correspondiente con dinero en efectivo.
                  </li>
                  <li>
                    Al confirmar tu pago, el cajero te entregará un comprobante
                    impreso. En él podrás verificar que se haya realizado
                    correctamente. Conserva este comprobante de pago.
                  </li>
                </ol>
                <base-error class="my-4" :errors="downloadError"></base-error>
                <v-btn
                  large
                  depressed
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold mt-7"
                  @click="onDownload"
                  :loading="isDownloading"
                  >Descargar</v-btn
                >
                <v-btn
                  large
                  text
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold mt-5"
                  @click="$router.go(-1)"
                  >Regresar</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col> </v-row
      ><img :src="output" />
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { to } from '@/helpers'
import { PaymentService } from '@/api/api.service'
import { pathOr } from '@/helpers/functional'
import { SESSION_ADD_PAYMENT } from '@/store/mutations.type'

export default {
  props: {},
  data() {
    return {
      reference: null,
      output: null,
      amount: 0,
      isDownloading: false,
      isLoading: true,
      downloadError: null,
      isBarcodeValid: true,
      barCodeOptions: {
        width: 1,
        format: 'CODE128',
        fontSize: 16,
        valid: (v) => this.setValid(v)
      }
    }
  },
  computed: {
    ...mapGetters({ user: 'getSessionUser', payment: 'getSessionPayment' })
  },
  mounted() {
    const query = this.$route.query || {}
    const rechargeAmount =
          query.recharge_amount ||
          new URLSearchParams(window.location.search).get('recharge_amount');

    this.getPaymentReference(rechargeAmount)

  },
  methods: {
    async getPaymentReference(rechargeAmount) {
      this.isLoading = true
      const payload = {}
      const paymentId = this.payment.id
      if (paymentId) {
        payload.payment_id = paymentId
      }

      if (rechargeAmount) {
        payload.recharge_amount = rechargeAmount
      }

      const [err, data] = await to(
        PaymentService.generatePaymentReference(payload)
      )
      if (err) {
        this.error = this.$t('errors.unknownError')
      } else {
        const paymentData = pathOr(null, ['data', 'data'], data)
        this.$store.commit(SESSION_ADD_PAYMENT, paymentData)
        this.reference = paymentData.payment.payment_gateway_id
        this.amount = pathOr([], ['data', 'data', 'payment', 'amount'], data)
      }
      this.isLoading = false
    },
    formatCurrency(value) {
      return this.$options.filters.thousands(value)
    },
    async onDownload() {
      this.isDownloading = true
      try {
        const el = this.$refs.downloadSection
        const options = {
          type: 'dataURL'
        }
        const ImageBase64 = await this.$html2canvas(el, options)
        var a = document.createElement('a')
        a.href = ImageBase64.replace('image/jpeg', 'image/octet-stream')
        const date = new Date().toISOString()
        a.download = `Pronto_OXXO_${date}.jpg`
        a.click()
        this.isDownloading = false
      } catch (error) {
        this.isDownloading = false
        this.downloadError =
          'Error al descargar, puedes tomar una captura de pantalla'
      }
    },
    setValid(v) {
      this.isBarcodeValid = v
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.v-sheet.v-alert {
  border: 0 !important;
  background-color: rgba(146, 72, 249, 0.1) !important;
  color: #2c3038 !important;
}
.v-alert--text:before {
  background-color: #fff;
}
.subtitle {
  font-size: 1rem;
}
.text-h2 {
  font-size: 3.5rem !important;
}
ol {
  font-size: 0.875rem;
  line-height: 1.45rem;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
</style>
